import {
  GET_OVERVIEW_CLASS_STARTED,
  GET_OVERVIEW_CLASS_SUCCESS,
  GET_OVERVIEW_CLASS_FAILURE,
  GET_ER_LEVELS_STARTED,
  GET_ER_LEVELS_SUCCESS,
  GET_ER_LEVELS_FAILURE,
  GET_OVERVIEW_YEAR_STARTED,
  GET_OVERVIEW_YEAR_SUCCESS,
  GET_OVERVIEW_YEAR_FAILURE,
  GET_OVERVIEW_VENUE_STARTED,
  GET_OVERVIEW_VENUE_SUCCESS,
  GET_OVERVIEW_VENUE_FAILURE
} from './RiskOverviewActions'


const initialState = {
  byClass: undefined,
  byYear: undefined,
  erLevels: undefined,
  error: undefined,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OVERVIEW_CLASS_STARTED:
      return {
        ...state
      }
    case GET_OVERVIEW_CLASS_SUCCESS:
      return {
        ...state,
        byClass: action.payload,
        error: undefined
      }
    case GET_OVERVIEW_CLASS_FAILURE:
      return {
        ...state,
        error: action.payload
      }
    case GET_OVERVIEW_YEAR_STARTED:
      return {
        ...state
      }
    case GET_OVERVIEW_YEAR_SUCCESS:
      return {
        ...state,
        byYear: action.payload,
        error: undefined
      }
    case GET_OVERVIEW_YEAR_FAILURE:
      return {
        ...state,
        error: action.payload
      }
    case GET_OVERVIEW_VENUE_STARTED:
      return {
        ...state
      }
    case GET_OVERVIEW_VENUE_SUCCESS:
      return {
        ...state,
        byVenue: action.payload,
        error: undefined
      }
    case GET_OVERVIEW_VENUE_FAILURE:
      return {
        ...state,
        error: action.payload
      }
    case GET_ER_LEVELS_STARTED:
      return {
        ...state,
      }
    case GET_ER_LEVELS_SUCCESS:
      return {
        ...state,
        erLevels: action.payload
      }
    case GET_ER_LEVELS_FAILURE:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}


